import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export function useBrand() {
  const route = useRoute();

  const isSicuraSolution = ref(false);

  watch(() => route.fullPath, (path) => {
    isSicuraSolution.value = path.includes('sicura-solution');
  }, { immediate: true });

  return {
    isSicuraSolution,
  };
}
